<template>
  <div>
    <EditViewProfile />
    <ParkingSpots v-if="user.show_parking_spots_map" />
    <SelectGuestParking />
    <Permits />
  </div>
</template>

<script>
import EditViewProfile from './EditViewProfile';
import Permits from './Permits';
import SelectGuestParking from './SelectGuestParking';
import ParkingSpots from './ParkingSpots';

export default {
  components: {
    EditViewProfile,
    Permits,
    SelectGuestParking,
    ParkingSpots,
  },
};

</script>

<style lang="scss" scoped>
.dashboard {
  &__content {
    margin-top: 0;
  }

  &__mainview {
    background-color: inherit;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/end-user/MainView.vue